<script setup lang="ts">
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    defineProps<{
        count: number;
        translationKey: string;
    }>();
</script>

<template>
    <span>
        {{ t(translationKey, { count: count }) }}
    </span>
</template>
